import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./pos.css";
import { useStorePos } from "./useStorePos";
import { useStoreLogin } from "../Login/useStoreLogin";
import { useStoreHome } from "../Home/useStoreHome";
import { useWindowDimensions, MensajeError } from "../../componentes/FuncionesLocales";
import { TabMenu } from "primereact/tabmenu";
import PosVenta from "./PosVenta";
import PosTicket from "./PosTicket";
import PosPopupPrecios from "./PosPopupPrecios";
import PosPopupStock from "./PosPopupStock";
import PosPopupCatalogarLinea from "./PosPopupCatalogarLinea";
import PosPendientesArca from "./PosPendientesArca";
import PosVentasRecientes from "./PosVentasRecientes";
import PosClienteNuevo from "./PosClienteNuevo";
import PosComprobacionFiscal from "./PosComprobacionFiscal";
import PosResultadoFacturacion from "./PosResultadoFacturacion";
import PosClientes from "./PosClientes";
import { useStoreCajas } from "../Cajas/useStoreCajas";
import CajaAperturaModal from "../Cajas/CajaAperturaModal";
import BotonInstructivo from "../../ComponentesGlobales/BotonInstructivo";
import { resolverPermisosPos } from "./permisosPos";

const Pos = () => {
  const { t } = useTranslation();
  const { width } = useWindowDimensions();
  const navigate = useNavigate();
  const location = useLocation();
  const permisosPos = resolverPermisosPos();
  const {
    puedeVender,
    puedeCatalogar,
    puedeVerClientes,
    puedeVerPrecios,
    puedeVerStock,
  } = permisosPos;
  const FechaCaducidad = useStoreHome((state) => state.FechaCaducidad);
  const [TabSeleccionado, setTabSeleccionado] = useState(puedeVender ? 0 : 2);
  const [SeccionMovil, setSeccionMovil] = useState(puedeVender ? "venta" : "recientes");
  const resultadoVenta = useStorePos((state) => state.ResultadoVenta);
  const aperturaRequerida = useStoreCajas((state) => state.aperturaRequerida);

  useEffect(() => {
    if (!useStoreLogin.getState().validarVariablesGlobales()) {
      useStoreLogin.getState().logout();
    }
    const cargarClientes = async () => {
      const lista = await useStorePos.getState().getClientes();
      if (!puedeVender) return;
      const consumidorFinalOk = await useStorePos.getState().cargarConsumidorFinal({
        cargarOpciones: false,
      });
      const clienteIdInicial = Number(location.state?.clienteId);
      const clienteInicial = lista.find((item) => Number(item.Id) === clienteIdInicial);
      if (clienteInicial) {
        await useStorePos.getState().setCliente(clienteInicial);
      } else if (consumidorFinalOk) {
        await useStorePos.getState().setConsumidorFinal();
      }
    };
    if (puedeVerClientes) void cargarClientes();
    if (puedeVender) {
      useStorePos.getState().getUnidades();
      useStorePos.getState().getCategoriasFiscales();
      useStorePos.getState().getFormasPago();
      useStorePos.getState().recuperarVentaPendiente();
      useStoreCajas.getState().resolverCaja();
    }
  }, [location.state?.clienteId, puedeVender, puedeVerClientes]);

  useEffect(() => {
    if (FechaCaducidad) {
      if (FechaCaducidad < new Date()) {
        MensajeError(t("auth.licenseExpired"));
        navigate("/home");
      }
    }
  }, [FechaCaducidad, navigate, t]);

  const itemsMovil = [
    ...(puedeVender ? [{ key: "venta", label: t("pos.newSale"), icon: "pi pi-shopping-cart" }] : []),
    { key: "recientes", label: t("pos.latest"), icon: "pi pi-history" },
    ...(puedeVender ? [{ key: "pendientes", label: t("pos.pending"), icon: "pi pi-clock" }] : []),
    ...(puedeVerClientes ? [{ key: "clientes", label: t("pos.customers"), icon: "pi pi-users" }] : []),
    ...(puedeVerPrecios ? [{ key: "precios", label: t("pos.prices"), icon: "pi pi-tags" }] : []),
    ...(puedeVerStock ? [{ key: "stock", label: t("pos.stock"), icon: "pi pi-box" }] : []),
  ];
  const indiceSeccionMovil = Math.max(0, itemsMovil.findIndex((item) => item.key === SeccionMovil));

  const tituloSeccion = width < 1024
    ? itemsMovil[indiceSeccionMovil]?.label
    : ({
      2: t("pos.latestSales"),
      3: t("pos.pendingArca"),
      4: t("pos.customers"),
      5: t("pos.priceList"),
      6: t("pos.stock"),
    }[TabSeleccionado] || t("pos.newInvoice"));

  return (
    <div className="pos">
      <div className="pos-header">
        <div className="pos-header-main">
          <span className="pos-icon-shell">
            <i className="pi pi-shopping-cart pos-icono" aria-hidden="true" />
          </span>
          <div>
            <h1 className="pos-titulo">{t("pos.title")} · {tituloSeccion}</h1>
          </div>
        </div>

        <BotonInstructivo to="/tutorial/ventas" sobreColor className="pos-tutorial-pendiente" />

        <nav className="pos-navbar" aria-label={t("pos.pointOfSaleActions")}>
          {puedeVerPrecios && <button
            type="button"
            className={`pos-nav-btn ${TabSeleccionado === 5 ? "activo" : ""}`}
            aria-pressed={TabSeleccionado === 5}
            onClick={() => setTabSeleccionado((actual) => actual === 5 ? (puedeVender ? 0 : 5) : 5)}
          >
            <i className="pi pi-tags" aria-hidden="true" />
            <span>{TabSeleccionado === 5 && puedeVender ? t("pos.newSale") : t("pos.prices")}</span>
          </button>}
          {puedeVerStock && <button
            type="button"
            className={`pos-nav-btn ${TabSeleccionado === 6 ? "activo" : ""}`}
            aria-pressed={TabSeleccionado === 6}
            onClick={() => setTabSeleccionado((actual) => actual === 6 ? (puedeVender ? 0 : 6) : 6)}
          >
            <i className="pi pi-box" aria-hidden="true" />
            <span>{TabSeleccionado === 6 && puedeVender ? t("pos.newSale") : t("pos.stock")}</span>
          </button>}
          <button
            type="button"
            className={`pos-nav-btn ${TabSeleccionado === 2 ? "activo" : ""}`}
            aria-pressed={TabSeleccionado === 2}
            onClick={() => setTabSeleccionado((actual) => actual === 2 ? (puedeVender ? 0 : 2) : 2)}
          >
            <i className="pi pi-history" aria-hidden="true" />
            <span>{TabSeleccionado === 2 && puedeVender ? t("pos.newSale") : t("pos.latestSales")}</span>
          </button>
          {puedeVender && <button
            type="button"
            className={`pos-nav-btn ${TabSeleccionado === 3 ? "activo" : ""}`}
            aria-pressed={TabSeleccionado === 3}
            onClick={() => setTabSeleccionado((actual) => actual === 3 ? 0 : 3)}
          >
            <i className="pi pi-clock" aria-hidden="true" />
            <span>{TabSeleccionado === 3 ? t("pos.newSale") : t("pos.pending")}</span>
          </button>}
          {puedeVerClientes && <button
            type="button"
            className={`pos-nav-btn ${TabSeleccionado === 4 ? "activo" : ""}`}
            aria-pressed={TabSeleccionado === 4}
            onClick={() => setTabSeleccionado((actual) => actual === 4 ? (puedeVender ? 0 : 4) : 4)}
          >
            <i className="pi pi-users" aria-hidden="true" />
            <span>{TabSeleccionado === 4 && puedeVender ? t("pos.newSale") : t("pos.customers")}</span>
          </button>}
        </nav>
      </div>

      {width < 1024 ? (
        <div className="pos-content-scroll">
          <div className="pos-mobile-tabs" aria-label={t("pos.pointOfSaleSections")}>
            <TabMenu
              model={itemsMovil}
              activeIndex={indiceSeccionMovil}
              onTabChange={(e) => setSeccionMovil(itemsMovil[e.index].key)}
            />
          </div>
          <div className="pos-layout animado-entrada">
            {SeccionMovil === "venta" && puedeVender && (
              resultadoVenta ? (
                <PosResultadoFacturacion />
              ) : (
                <div className="pos-mobile-sale-flow">
                  <div className="pos-mobile-sale-entry">
                    <PosVenta modoRapido />
                  </div>
                  <div className="pos-registros pos-mobile-cart">
                    <PosTicket modoRapido />
                  </div>
                </div>
              )
            )}
            {SeccionMovil === "recientes" && <PosVentasRecientes />}
            {SeccionMovil === "pendientes" && puedeVender && <PosPendientesArca />}
            {SeccionMovil === "clientes" && puedeVerClientes && <PosClientes />}
            {SeccionMovil === "precios" && puedeVerPrecios && <PosPopupPrecios />}
            {SeccionMovil === "stock" && puedeVerStock && <PosPopupStock />}
          </div>
        </div>
      ) : (
        <div className="pos-content-scroll">
          {TabSeleccionado >= 2 ? (
            <div className="pos-layout animado-entrada pos-layout-pendientes">
              {TabSeleccionado === 2 && <PosVentasRecientes />}
              {TabSeleccionado === 3 && puedeVender && <PosPendientesArca />}
              {TabSeleccionado === 4 && puedeVerClientes && <PosClientes />}
              {TabSeleccionado === 5 && puedeVerPrecios && <PosPopupPrecios />}
              {TabSeleccionado === 6 && puedeVerStock && <PosPopupStock />}
            </div>
          ) : puedeVender ? (
            <div className={`pos-layout pos-layout-comprobante animado-entrada ${resultadoVenta ? "pos-layout-pendientes" : ""}`}>
              {resultadoVenta ? (
                <PosResultadoFacturacion />
              ) : (
                <section className="pos-comprobante" aria-label={t("pos.salesReceipt")}>
                  <div className="pos-formulario"><PosVenta /></div>
                  <div className="pos-registros"><PosTicket /></div>
                </section>
              )}
            </div>
          ) : null}
        </div>
      )}

      {puedeCatalogar && <PosPopupCatalogarLinea />}
      {puedeVerClientes && <PosClienteNuevo />}
      {puedeVender && <PosComprobacionFiscal />}
      {puedeVender && <CajaAperturaModal
        abierto={aperturaRequerida}
        onCerrar={() => useStoreCajas.setState({ aperturaRequerida: false })}
      />}
    </div>
  );
};

export default Pos;
